import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { TimeSlotKeyDto } from "../../../Models/Reservation/TimeSlotKeyDto";
import { IAddToCartRequest } from "../../../Models/Tickets/IAddToCartRequest";
import { AxBooking, AxProdBookingInit } from "../Abstraction/AxBooking";

@ModuleName("AxProdBooking")
export class AxProdBooking extends AxBooking implements AxInit {
    private serviceVoucherCoverage: Record<string, number> = {};

    constructor() { super(); }

    AxInit(initData: AxProdBookingInit): void {
        this.Init(initData);

        // Initialize service voucher coverage if available
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("serviceVoucher") === "true") {
            const personTypeIds = urlParams.getAll("personTypeId");

            personTypeIds.forEach(id => {
                if (this.serviceVoucherCoverage[id]) {
                    this.serviceVoucherCoverage[id]++;
                } else {
                    this.serviceVoucherCoverage[id] = 1;
                }
            });
        }
    }

    AddToCart(): void {
        if (this.productSelection.ProductList.filter(x => x.Quantity > 0).length > 0) {
            const urlParams = new URLSearchParams(window.location.search);
            let requestObj: IAddToCartRequest = {
                Date: this.selectedDate,
                ProjNr: this.productSelection.ProjNr,
                PoolNr: this.productSelection.ProductGroupIdentifier,
                TicketTypeId: this.productSelection.Id,
                PersonTypes: [],
                TimeSlotKeys: [],
                Barcode: urlParams.get('barcode'),
            };

            // Add selected time slots to the request object
            for (let timeSlot of this.selectedTimeSlots) {
                requestObj.TimeSlotKeys.push(new TimeSlotKeyDto(timeSlot.timeSlotKey));
            }

            // Add person types and quantities to the request object
            for (let prod of this.productSelection.ProductList) {
                if (prod.Quantity > 0) {
                    requestObj.PersonTypes.push({
                        PersonTypeId: prod.SubProductIdentifier,
                        Quantity: prod.Quantity
                    });
                }
            }

            // Prepare the post URL with service voucher information
            let postUrl = this.postURL;
            if (Object.keys(this.serviceVoucherCoverage).length > 0) {
                if (postUrl.indexOf('?') === -1) {
                    postUrl += '?serviceVoucher=true';
                } else {
                    postUrl += '&serviceVoucher=true';
                }

                // Append person type IDs with coverage to the URL
                Object.keys(this.serviceVoucherCoverage).forEach(personTypeId => {
                    for (let i = 0; i < this.serviceVoucherCoverage[personTypeId]; i++) {
                        postUrl += `&personTypeId=${personTypeId}`;
                    }
                });
            }

            // Redirect to the summary page
            this._summaryRedirect.redirect(postUrl, requestObj, true);
        }
    }
}
